import Vue from 'vue'


const url = Vue.prototype.$config.api_url +
  Vue.prototype.$config.azmoon.report_settings
const reportSettings = {

  edit(id:string|number, payload:any) {
    let uri = url;
    return Vue.prototype.$httpService
      .put(`${uri}/${id}` , payload)
  },

  list(params = {}) {
    let uri = url;
    return Vue.prototype.$httpService.get(uri,
      params
    )
  },
}

export default reportSettings;
